<template>
  <LayoutPrimary>
    <router-view :key="$route.fullPath" />
  </LayoutPrimary>
</template>

<script>
  import LayoutPrimary from '@modules/v2/layout/layout-primary'
  import { mapGetters } from 'vuex'

  export default {
    name: 'AdminSurveysRootView',
    components: {
      LayoutPrimary,
    },
    created: function () {
      if (
        !this.isAdmin ||
        !this.isEnterprise
      ) {
        this.$store.commit('notification/setMessage', 'Access denied');
        this.$router.push({
          name: 'private-home',
        });
      }
    },
    computed: {
      ...mapGetters('tenant', ['isEnterprise']),
      ...mapGetters('tenantUser', ['isAdmin']),
    },
  };
</script>
